import React, { useEffect, useRef, forwardRef, useImperativeHandle, useState, useCallback } from 'react'
import cloneDeep from 'lodash/cloneDeep'
import Chart from 'component/chart/base'
import { color } from '../color'
import styles from './index.module.less'

export default forwardRef(({ centerText, onHoverPie = () => {}, data, getHref }, ref) => {
  const chartInstance = useRef()
  const $chart = useRef()
  const [centerTextName, setCenterTextName] = useState()
  const [allowBack, setAllowBack] = useState(false)
  const [parentData, setParentData] = useState([])
  const [source, setSource] = useState([])

  useEffect(() => {
    setAllowBack(false)
    setSource(cloneDeep(data))
    setCenterTextName(centerText)
    setParentData(cloneDeep(data))
  }, [JSON.stringify(data)])

  const _onSelectPie = (_data) => {
    const _result = _data.data
    if (_result.children && _result.children?.length) {
      setCenterTextName(_result.name)
      setSource(_result.children)
      setAllowBack(true)
    }
  }

  const onBack = () => {
    setAllowBack(false)
    setCenterTextName(centerText)
    setSource(cloneDeep(parentData))
  }

  useImperativeHandle(ref, () => ({
    chartInstance: chartInstance.current
  }))

  useEffect(() => {
    if (!$chart.current) return
    chartInstance.current = $chart.current.getEchartsInstance()
    chartInstance.current.on('click', 'series', _onSelectPie)
    chartInstance.current.on('mouseover', 'series', onHoverPie)
    return () => {
      chartInstance.current.off('click')
      chartInstance.current.off('mouseover')
    }
  }, [$chart.current])

  const getPointBg = useCallback((index) => {
    if (color) {
      return { backgroundColor: color[(index) % 13] }
    }
    return {}
  }, [color])

  return <div className={styles['meinian-pie-chart']}>
    <div className={styles['meinian-pie-chart-legend']}>
      {source.map((item, index) => <div className={styles['meinian-pie-chart-legend-item']}>
        <div className="df-center">
          <div className={styles['meinian-nest-menu-parent-point']} style={{ ...getPointBg(index) }} />
          <div className={styles['meinian-nest-menu-parent-name']}>{item.name}</div>
        </div>
        <div className="df-center">
          <div className={styles['meinian-nest-menu-num']}>{item.value}</div>
          <div className={styles['meinian-nest-menu-num-line']} />
          <div className={styles['meinian-nest-menu-num']}>{item.percentage}%</div>
        </div>
      </div>)}
    </div>
    <Chart
      ref={$chart}
      className="meinian-pie-chart-content"
      type={null}
      contentSlot={allowBack ? <div className={styles['meinian-pie-center-text']}>
        <div>{centerTextName}</div>
        <a className="back" onClick={onBack}>返回</a>
      </div> : <div className={styles['meinian-pie-center-text']}>{centerTextName}</div>}
      customConfig={{
        color,
        tooltip: {
          trigger: 'item',
          enterable: true,
          textStyle: { color: '#1D1D1F', fontWeight: 400, fontSize: 14, lineHeight: 28 },
          formatter: (a) => {
            if (!a.data) {
              return
            }
            let tip = `<div style='width:200px;'>
              <div>${a.marker}${a.name}</div>
              <div style='display:flex;margin-left:16px;align-items: center;'>
                <span>${a.data?.value}&nbsp;</span>
                <span style='color: var(--m-text-3);'>款</span>
                <span style='color: var(--m-line-1);margin:0px 6px;'>|</span>
                <span style='color: var(--m-text-3);'>占比&nbsp;</span>
                <span>${a.data?.percentage}%</span>
              </div>
            </div>`
            const href = getHref?.(a.data)
            if (href) {
              tip += `<a target="_blank"
              style='color: var(--m-text-1);text-align: right;width:200px;display:block;margin-top:6px;'
              href=${`${href}`}>查看款式 &gt;</a>`
              return tip || 'Loading'
            }
            return tip || 'Loading'
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['65%', '95%'],
            center: ['50%', '50%'],
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            data: source,
          }
        ],
      }}
    />
  </div>
})
